import * as React from "react";
import { BarChart } from "@mui/x-charts/BarChart";

export default function SupplyChart() {
  return (
    <div
      className="
      flex
      flex-col
      mt-12
      mx-5
      justify-center
      rounded-xl
      max-w-7xl
      lg:w-[70%]
      p-8
      backdrop-blur-lg
      gap-4
      text-center text-white text-3xl
    "
    >
      <p>TOTAL SUPPLY</p>
      <BarChart
        series={[{ data: [35, 44, 24, 34] }]}
        height={300}
        grid={{ vertical: true, horizontal: true }}
        borderRadius={8}
        xAxis={[{ data: ["Q1", "Q2", "Q3", "Q4"], scaleType: "band" }]}
        margin={{ top: 10, bottom: 30, left: 40, right: 10 }}
      />
    </div>
  );
}
